import React from 'react';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';
import Input from '../components/general/Input';
import Button from '../components/general/Button';
import TestimonialsImage from "../assets/hire-developer/Testimonials.png";
import Image from '../components/general/Image';
import { axiosUnauthInstance } from '../service/API';
import { setShowSuccessModal } from '../redux/slice/commonSlice';
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { contactUsValidationSchema } from '../utils/validation'
import PhoneController from '../components/common/controller/PhoneController';

const ContactUs = () => {
    const dispatch = useDispatch();
    const { reset, control, register, handleSubmit, formState: { errors, isValid } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(contactUsValidationSchema)
    });

    const onSubmit = async (data) => {
        const payload = {
            ...data,
            name: `${data.name} (From Contact Us Page)`
        }
        try {
            const response = await axiosUnauthInstance.post('/leads/', payload);
            if (response.status === 201) {
                toast.success('Thank you for your interest in our services. We will get back to you soon.');
                reset();
                dispatch(setShowSuccessModal(true));
            }
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
    }

    return (
        <>
            <Header />
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col md:flex-row items-center justify-between min-h-screen bg-black --layout-padding">
                {/* Left Part */}
                <div className="max-w-4xl w-full lg:w-[50%] p-6 rounded-lg shadow-md bg-[#292929]">
                    <h1 className="text-3xl font-bold text-center text-white">Contact Us</h1>
                    <p className="mt-4 text-center text-white">
                        We’d love to hear from you! Please fill out the form below and we’ll get back to you as soon as possible.
                    </p>

                    <form className="mt-8 space-y-6">
                        <div>
                            <Input
                                type="text"
                                label={"First Name"}
                                className='text-white bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[40px]'
                                placeholder='First Name'
                                name="name"
                                register={register}
                                error={errors.name?.message}
                            />
                        </div>
                        <div>
                            <Input                                
                                type="email"
                                label={"Email"}
                                className='text-white bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full h-[40px]'
                                placeholder='Email'
                                name="email"
                                register={register}
                                error={errors.email?.message}
                            />
                        </div>
                        <div>
                        <label className="block text-sm font-medium text-primary-color mb-[10px]">Phone</label>
                        <PhoneController
                            la
                            name={"phone"}
                            control={control}
                            placeholder="Phone Number"
                        />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-primary-color mb-[10px]">Message</label>
                            <textarea
                                label={"Message"}
                                rows={4}
                                className='text-white bg-transparent border border-gray-300 rounded-md p-[10px] outline-none w-full'
                                placeholder='Message'
                                {...register("message")}
                            ></textarea>
                            {
                                errors.message && (
                                    <p className='text-red-500 text-[14px]'>{errors.message.message}</p>
                                )
                            }
                        </div>
                        <div>
                            <Button
                                onClick={handleSubmit(onSubmit)}
                                type="submit"
                                className="w-full py-2 px-4 bg-primary-color text-black rounded-md shadow focus:outline-none"
                            >
                                Send Message
                            </Button>
                        </div>
                    </form>
                </div>

                {/* Right Part */}
                <div className="hidden md:flex flex-col items-center justify-center w-full md:w-1/2 p-6 lg:w-[40%]">
                    <img
                        src="https://via.placeholder.com/400" // Replace with your image URL
                        alt="Contact Us"
                        className="rounded-lg shadow-lg"
                    />
                    <div className="mt-4 text-center">
                        <h2 className="text-xl font-semibold text-primary-color">Get in Touch</h2>
                        <p className="mt-2 text-white">
                            Have questions? We’re here to help! Reach out to us anytime.
                        </p>
                    </div>
                    <Image src={TestimonialsImage} alt="Contact Us" className="rounded-lg shadow-lg mt-[20px]" />
                </div>
            </form>

            <Footer />
        </>
    );
};

export default ContactUs;
